let currentIndex = 0;

export const setSwiperIndex = (index) => {
  currentIndex = index;
};

export const getSwiperIndex = () => {
  return currentIndex;
};